module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couponMod",
    class: _vm.status == 1 ? 'useCouponMod' : ''
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.couponType === 'deduction') ? _c('span', {
    staticClass: "content"
  }, [_c('h2', [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sum.split('.')[0]))]), _c('span', [_vm._v("." + _vm._s(_vm.sum.split('.')[1]))])]), _vm._v(" "), _c('p', [_vm._v("优惠券")])]) : _c('span', {
    staticClass: "content"
  }, [_c('h2', [_c('span', {
    staticClass: "sum"
  }, [_vm._v(_vm._s((_vm.sum / 10).toFixed(1)))]), _vm._v("折")]), _vm._v(" "), _c('p', [_vm._v("打折券")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: _vm.backgroundFn
  }, [_c('div', {
    staticClass: "business"
  }, [_vm._v("\n        " + _vm._s(_vm.serviceType) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v("有效时间\n          "), _c('span', [_vm._v(_vm._s(_vm.startTime))]), _vm._v("\n          ~\n          "), _c('span', [_vm._v(_vm._s(_vm.endTime))])])])])]), _vm._v(" "), (_vm.useState === 1) ? _c('div', {
    staticClass: "bottom"
  }, [(_vm.overdueTime !== '') ? _c('span', [_vm._v(_vm._s(_vm.overdueTime !== '永久有效' ? _vm.overdueTime : '永久'))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.overdueTime !== '永久有效' ? (_vm.overdueTime && _vm.overdueTime !== '' ? '后过期' : '已过期') : '有效') + "\n  ")]) : (_vm.useState === 2) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n    已使用\n  ")]) : (_vm.useState === 3) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n    已失效\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35fec67a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/couponMod/src/couponMod.vue
// module id = 522
// module chunks = 0